import { types } from "../../types/types";

const initialState = {
    areasFisicas: [],
    subAreasFisicas: [],
    areaFisicaUsuario: null,

    loading: false
};

export const areasFisicasReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.areasFisicasReducerStart:
            return {
            ...state,
            loading: true,
            };
        case types.areasFisicasReducerEnd:
            return {
                ...state,
                loading: false,
            };
        case types.getAreasFisicas:
            return {
                ...state,
                areasFisicas: action.payload,
            };
        case types.cleanAreasFisicas:
            return {
                ...state,
                areasFisicas: [],
            };
        case types.getSubAreasFisicas:
            return {
                ...state,
                subAreasFisicas: action.payload,
            };
        case types.cleanSubAreasFisicas:
            return {
                ...state,
                subAreasFisicas: [],
            };
        case types.getUsuarioAreasFisicas:
            return {
                ...state,
                areaFisicaUsuario: action.payload,
            };

        case types.newStateAreaFisica:
            return {
                ...state,
                areaFisicaUsuario: action.payload,
            };
        case types.deleteAreaFisica:
            return {
                ...state,
                areaFisicaUsuario: {
                    idUsuario: action.payload,
                    idArea: "",
                    idSubArea: ""
                },
            };

        case types.cleanUsuarioAreasFisicas:
            return {
                ...state,
                areaFisicaUsuario: null,
            };
        case types.putAreaFisica:
            return {
                ...state,
                areasFisicas: state.areasFisicas.map(area=>(
                    area.idArea === action.payload.idArea
                    ? action.payload : area
                ))
            };
        case types.removeAreaFisica:
            return {
                ...state,
                areasFisicas: state.areasFisicas.filter((item)=>{return item.idArea !== action.payload})
            };
        case types.newAreaFisica:
            return {
                ...state,
                areasFisicas: [...state.areasFisicas, action.payload]
            }
        default:
            return state;
    }
  };

export const startAreasFisicasReducer = () => ({ type: types.areasFisicasReducerStart });
export const endAreasFisicasReducer = () => ({ type: types.areasFisicasReducerEnd });

export const getAreasFisicas = (data) => ({ type: types.getAreasFisicas, payload: data });
export const cleanAreasFisicas = () => ({ type: types.cleanAreasFisicas });

export const getSubAreasFisicas = (data) => ({ type: types.getSubAreasFisicas, payload: data });
export const cleanSubAreasFisicas = () => ({ type: types.cleanSubAreasFisicas });

export const newStateAreasFisicas = (data) => ({ type: types.newStateAreaFisica, payload: data });
export const deleteAreasFisicas = (data) => ({ type: types.deleteAreaFisica, payload: data });

export const getUsuarioAreasFisicas = (data) => ({ type: types.getUsuarioAreasFisicas, payload: data });
export const cleanUsuarioAreasFisicas = () => ({ type: types.cleanUsuarioAreasFisicas });

export const putAreaFisica = (data) => ({type: types.putAreaFisica, payload: data});
export const removeAreaFisica = (data) => ({type: types.removeAreaFisica, payload: data});
export const newAreaFisica = (data) => ({type: types.newAreaFisica, payload: data});
